import { Component, OnInit,ViewChild } from '@angular/core';
import { pageContent } from '../models/pageContent';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../service/tableUtility.service';
@Component({
  selector: 'app-pagecontentmanagement',
  templateUrl: './pagecontentmanagement.component.html',
  styleUrls: ['./pagecontentmanagement.component.css']
})
export class PagecontentmanagementComponent implements OnInit {

  pageContentAddObj:pageContent
  dataSource:any;
  displayedColumns = [ 'screenId', 'screenName','text','dateOfCreation','dateOfModification','Action']
  userDetails:any;
  userSessionData:any
  read:any;
  write:any;
  delete:any
  image = { 'URL': '', 'valid': false };
  myurl: string;

  @ViewChild("pageContent") form: any;
  @ViewChild("pageContentUpdate") formUpdate: any;

  @ViewChild(MatSort,{static:true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  editor = ClassicEditor;
  tableData: [] = [];
  data:any
  show:boolean=false
  constructor( private cs:CucurachaAdminService,private toastr: ToastrManager, private excelService: ExcelService) {
    this.pageContentAddObj= new pageContent();
    this.myurl = this.cs.endpoint;

   }
   applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
   savePageContentManagement(){
    console.log(this.pageContentAddObj)
    this.cs.savePageContent(this.pageContentAddObj).subscribe((data) => {
      if(data.result ){
        this.getAllPageContent();
        this.toastr.successToastr(data.message);
        this.form.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
   }
  addPageContent(){
    if(this.show==false){
      this.show=true
      this.form.reset()

    }
    else{
      this.show=false
      this.form.reset()

    }
  }
  getAllPageContent(){
    this.cs.getAllPageContent().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }
  getPageContentById(id:any){
    this.cs.getPageContentById(id).subscribe((data) => {
      this.pageContentAddObj._id = data[0]._id;

      this.pageContentAddObj.screenId = data[0].screenId
      this.pageContentAddObj.screenName = data[0].screenName
      this.pageContentAddObj.title = data[0].title
     
    })
  }
 
  updatePageContent(){
    this.cs.updatePageContent(this.pageContentAddObj).subscribe((data) => {
      if(data.result ){
        this.getAllPageContent();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
  }
  fileChangeEvent(event) {
    if (event.target.files && event.target.files[0]) {
      var rd = new FileReader();
      rd.onload = (ev: any) => {
       //this.data = ev.target.result;
        this.pageContentAddObj.fileUpload = ev.target.result
        console.log(  this.pageContentAddObj.fileUpload)
        this.pageContentAddObj.fileUpload=this.pageContentAddObj.fileUpload.replace("data:application/pdf;base64,","")

        //this.image.URL = ev.target.result;data:application/vnd
      }
      rd.readAsDataURL(event.target.files[0]);
    }
  }
  ngOnInit(): void {
    this.getAllPageContent();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].pageContent_management.permissions[0].read);
      this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].pageContent_management.permissions[0].write)
      this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].pageContent_management.permissions[0].delete)
    })
  }

}
